import Context from 'managers/Context';
import {
    APIKEY_INFO_LOADING,
    APIKEY_INFO_SUCCESS,
    APIKEY_INFO_ERROR,
    APIKEY_GENERATE_LOADING,
} from 'constants/ActionTypes';

function _showLoading() {
    return { type: APIKEY_INFO_LOADING };
}

function _loadInfo(apiKey, privateApiKey) {
    return {
        type: APIKEY_INFO_SUCCESS,
        payload: { apiKey, privateApiKey },
    };
}

function _showError(error) {
    return {
        type: APIKEY_INFO_ERROR,
        payload: { error },
    };
}

function _showLoadingCreation() {
    return { type: APIKEY_GENERATE_LOADING };
}

function _apiKeyRequest(loadingAction, request, success, errorCallback) {
    return (dispatch) => {
        dispatch(loadingAction());
        request(
            (apiKey, privateApiKey) => {
                dispatch(_loadInfo(apiKey, privateApiKey));
                success?.();
            },
            () => {
                dispatch(_showError('Error'));
                errorCallback?.();
            },
        );
    };
}

export function getApiKey(success, errorCallback) {
    return _apiKeyRequest(
        _showLoading,
        (...args) => Context.domainManager.getApiKey(...args),
        success,
        errorCallback,
    );
}

export function createApiKey(success, errorCallback) {
    return _apiKeyRequest(
        _showLoadingCreation,
        (...args) => Context.domainManager.createApiKey(...args),
        success,
        errorCallback,
    );
}
